import(/* webpackMode: "eager" */ "/var/www/tripcraftmx/frontend/src/app/[locale]/pasion-futbolera-experiencia-total/page.tsx");
